// @flow

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Switch from "@material-ui/core/Switch";
import FilterList from "@material-ui/icons/FilterList";
import Done from "@material-ui/icons/Done";
import Clear from "@material-ui/icons/Clear";
import type { ICPCTableColumn } from "./types";

const styles = (theme) => ({
  track: {},
  checked: {
    color: theme.palette.secondary[500],
    "& + $bar": {
      backgroundColor: theme.palette.secondary[500],
    },
  },
});

type Props = {
  classes: Object,
  onSwitchChange: Function,
  filterChecked: boolean,
  columns: Array<ICPCTableColumn>,
  activeColumnsNames: Array<string>,
};

const TableOptions = (props: Props) => {
  const {
    classes,
    onSwitchChange,
    filterChecked,
    columns,
    activeColumnsNames,
  } = props;
  return (
    <div className={classes.root}>
      <List subheader={<ListSubheader>Filter</ListSubheader>}>
        <ListItem>
          <ListItemIcon>
            <FilterList />
          </ListItemIcon>
          <ListItemText primary={filterChecked ? "Combined" : "Separate"} />
          <ListItemSecondaryAction>
            <Switch
              classes={{ checked: classes.checked, track: classes.track }}
              onChange={onSwitchChange("filter")}
              checked={filterChecked}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <List
        subheader={<ListSubheader>Columns</ListSubheader>}
        data-test={"table-columns"}
      >
        {columns.map((column, idx) => {
          const active = activeColumnsNames.includes(column.name);
          return (
            <ListItem key={idx}>
              <ListItemIcon>{active ? <Done /> : <Clear />}</ListItemIcon>
              <ListItemText primary={column.title} />
              <ListItemSecondaryAction>
                <Switch
                  classes={{ checked: classes.checked, track: classes.track }}
                  onChange={onSwitchChange(column.name)}
                  checked={active}
                  data-test={column.name}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default withStyles(styles)(TableOptions);
